import {
  negate13xrbakfwasjy as negate,
  shiftRight2gqph14wydb8s as shiftRight,
  shiftRightUnsigned1ga7wnvbv2qur as shiftRightUnsigned,
  convertToInty04h231mmjoh as convertToInt,
  numberToLong2pakxeg38estk as numberToLong,
  toNumber2e2hj9zugjwi2 as toNumber,
} from '../js/internal/longAsBigInt/longAsBigInt.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../js/numberConversion.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { isNaNymqb93xtq8w8 as isNaN_0 } from '../NumbersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function round(x) {
  if (!(x % 0.5 === 0.0)) {
    return Math.round(x);
  }
  // Inline function 'kotlin.math.floor' call
  var floor = Math.floor(x);
  var tmp;
  if (floor % 2 === 0.0) {
    tmp = floor;
  } else {
    // Inline function 'kotlin.math.ceil' call
    tmp = Math.ceil(x);
  }
  return tmp;
}
function abs(n) {
  return n < 0 ? -n | 0 : n;
}
function abs_0(n) {
  return n < 0n ? negate(n) : n;
}
function get_sign(_this__u8e3s4) {
  return convertToInt(shiftRight(_this__u8e3s4, 63) | shiftRightUnsigned(negate(_this__u8e3s4), 63));
}
function roundToInt(_this__u8e3s4) {
  var tmp;
  if (isNaN_0(_this__u8e3s4)) {
    throw IllegalArgumentException().o2('Cannot round NaN value.');
  } else if (_this__u8e3s4 > 2147483647) {
    tmp = 2147483647;
  } else if (_this__u8e3s4 < -2147483648) {
    tmp = -2147483648;
  } else {
    tmp = numberToInt(Math.round(_this__u8e3s4));
  }
  return tmp;
}
function roundToLong(_this__u8e3s4) {
  var tmp;
  if (isNaN_0(_this__u8e3s4)) {
    throw IllegalArgumentException().o2('Cannot round NaN value.');
  } else if (_this__u8e3s4 > toNumber(9223372036854775807n)) {
    tmp = 9223372036854775807n;
  } else if (_this__u8e3s4 < toNumber(-9223372036854775808n)) {
    tmp = -9223372036854775808n;
  } else {
    tmp = numberToLong(Math.round(_this__u8e3s4));
  }
  return tmp;
}
//region block: exports
export {
  abs as abs1kdzbjes1idip,
  abs_0 as abs22kdeprm0tm5i,
  roundToInt as roundToInt1ue8x8yshtznx,
  roundToLong as roundToLong2s902lrwaad4n,
  round as round2mrvepag8eey0,
  get_sign as get_signed9wrgmju9wx,
};
//endregion

//# sourceMappingURL=math.mjs.map
